import axios from "axios";
import authHeader from '../../../authheader'

const EFAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/FirmEfApplication";



const getBoardRecommendations = (applicationId) => {
    return axios.get(`${EFAPPLICATIONURL}/boardrecommendations`, { headers: authHeader(), params: { applicationId } });
}
const getBoardResponses = (applicationId) => {
    return axios.get(`${EFAPPLICATIONURL}/boardmemberresponses`, { headers: authHeader(), params: { applicationId } });
}
const postBoardRecommendation = (data) => {
    return axios.post(`${EFAPPLICATIONURL}/boardrecommendation`, data, { headers: authHeader() });
}
const postBoardResponse = (data) => {
    var header = authHeader();
    header['Content-Type'] = 'multipart/form-data';
    return axios.post(`${EFAPPLICATIONURL}/boardmemberresponse`, data, { headers: { ...header } });
}
export default {
    getBoardRecommendations,
    getBoardResponses,
    postBoardRecommendation,
    postBoardResponse
}